import React, { useContext } from "react"
import PropTypes from "prop-types"
import { CollapseContext } from "../context/CollapseContext"

import styled from "styled-components"

import { GrUp, GrDown } from "react-icons/gr"

const CollapseContainer = styled.div`
  border-top: 3px solid #1a0b75;
  padding-top: 2px;

  flex-grow: 1;
  @media only screen and (max-width: 500px) {
    margin: 0 5px;
  }
`

const CollapseButton = styled.div`
  font-weight: bold;
  font-size: 26px;

  border-top: 2px solid #b9342d;

  background-color: white;
  cursor: pointer;
  padding: 15px;
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and (max-width: 500px) {
    font-size: 23px;
  }
`

const CollapseIcon = styled.div`
  svg {
    polyline {
      stroke: #555;
    }
  }
`

const Collapse = ({ unicTitle, headerComponent, defaultStatus, children }) => {
  const { toggleCollapse, setDefault, isOpen } = useContext(CollapseContext)
  setDefault(unicTitle, defaultStatus)

  return (
    <CollapseContainer>
      <CollapseButton
        onClick={() => {
          toggleCollapse(unicTitle)
        }}
      >
        {headerComponent === undefined ? unicTitle : headerComponent}
        <CollapseIcon>{isOpen(unicTitle) ? <GrUp /> : <GrDown />}</CollapseIcon>
      </CollapseButton>
      {isOpen(unicTitle) ? <div>{children}</div> : null}
    </CollapseContainer>
  )
}

// The toggle functionality is kept on a context to keep the state when going comming back to the page
// it keeps the state in context based on the title
Collapse.propTypes = {
  unicTitle: PropTypes.string.isRequired,
}

export default Collapse
